import React from 'react';
import { Drawer, Row, Col, Button, Icon } from 'antd';
import {
  selectPeriod,
  resetFilter,
  toggleFilterVisble,
  selectAddress,
  toggleOnlyActive,
} from '../../../../features/filter';
import styles from './Filter.module.scss';

const { SelectPeriod } = selectPeriod;
const { SelectAddress } = selectAddress;
const { ToggleOnlyActive } = toggleOnlyActive;
const { ResetFilter } = resetFilter;
const { useFilterVisibleState, useFilterVisibleDispatch } = toggleFilterVisble;

const Filter = () => {
  const visible = useFilterVisibleState();
  const close = useFilterVisibleDispatch();

  return (
    <Drawer
      title="Фильтр"
      visible={visible}
      onClose={close}
      width={520}
      drawerStyle={{ backgroundColor: '#f9f9f9' }}
      bodyStyle={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
    >
      <Row gutter={16}>
        <Col span={24}>
          <SelectPeriod />
        </Col>
      </Row>
      <SelectAddress />
      <Row>
        <Col>
          <ToggleOnlyActive />
        </Col>
      </Row>
      <Row>
        <Col offset={14} span={10}>
          <ResetFilter
            render={({ reset }) => (
              <Button className={styles.resetBtn} onClick={reset}>
                <Icon type="sync" className={styles.resetBtnIcon} />
                Сбросить фильтр
              </Button>
            )}
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default Filter;
